import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';
import { getRouteApi } from '@mint/routing';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

type UseTotalsRowApiParams = {
  enabled?: boolean;
};

export const useTotalsRowApi = ({
  enabled = true,
}: UseTotalsRowApiParams = {}) => {
  const { campaignId: planId } = routerApi.useParams();

  return useQuery({
    ...MediaPlan.getTotalsRowQueryOptions({
      urlParams: {
        planId,
      },
    }),
    enabled,
  });
};
